(function () {
  'use strict';
  var root = document.querySelector('.ff-root');
  if (!root) return;

  // Revelado al scrollear. Se activa recién acá (no por CSS) y tiene red de seguridad:
  // si algo queda sin revelar a los 3.5 s (render lazy), se muestra igual.
  var nodes = root.querySelectorAll('.ff-rev');
  if ('IntersectionObserver' in window && nodes.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ff-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });
    root.classList.add('ff-go');
    void document.body.offsetHeight;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { nodes.forEach(function (n) { io.observe(n); }); });
    });
    setTimeout(function () {
      root.querySelectorAll('.ff-rev:not(.ff-in)').forEach(function (n) { n.classList.add('ff-in'); });
    }, 3500);
  }

  // Comprar desde la landing: dispara el botón real de la ficha de producto.
  // Si no hay ficha en la página, navega al href (/cart/VARIANTE:1).
  var BUY = 'product-form button[name="add"], .product-form__submit, button[name="add"]';
  root.querySelectorAll('[data-ff-buy]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var btn = document.querySelector(BUY);
      if (!btn) return;
      ev.preventDefault();
      btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { btn.click(); } catch (e) { /* si falla, queda el scroll */ }
    });
  });

  // Scroll suave en anclas internas.
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();
